// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"401a3922","453":"0680a3c0"}[chunkId] + ".chunk.js";
};